import { lazy } from 'react';

export const InOutBookList = lazy(() => import('./in_out_book/InOutBookList'));
export const VisitorMonitoring = lazy(() => import('./visitor_monitoring/VisitorMonitoring'));
export const GateOperations = lazy(() => import('./gate_operations/GateOperations'));
// export const InOutDetails = lazy(() => import('./in_out_details/InOutDetails'));
export const InOutEntries = lazy(() => import('./in_out_book/InOutEntries'));
export const VisitorAndGatePass = lazy(() => import('./visitor-gatepass/VisitorAndGatePass'));
export const PreApprovedVisitorList = lazy(() => import('./pre_approved_visitor/PreApprovedVisitorList'));
export const VisitorApprovalRequestList = lazy(() => import('./visitor_approval_request/VisitorApprovalRequestList'));
export const MyVisitorList = lazy(() => import('./my_visitor/MyVisitorList'));
export const OverStayList = lazy(() => import('./over_stay/OverStayList'));
export const VisitorManagementSystem = lazy(() => import('./visitor_management_system/VisitorManagementSystem'));
export const DirectoryAndStaff = lazy(() => import('./directory_staff/DirectoryAndStaff'));